export default __webpack_public_path__ + "static/media/dashboard_group_image_lokalac.b22c2bdc.png";